import React from 'react';
import { Form } from 'semantic-ui-react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './EditMarketForm.form';
import { MarketAPI } from '../../../../api';
import { useAuth } from '../../../../hooks';

const marketController = new MarketAPI();

export function EditMarketForm(props) {
    const { close, onReload, market } = props;
    const { accessToken } = useAuth();
    
    const formik = useFormik({
        initialValues: initialValues(market),
        validationSchema: validationSchema(market),
        validateOnChange: false,
        onSubmit: async(formValue) => {
            try {
                console.log("formValue" , formValue);
                await marketController.updateMarket(accessToken, market._id, formValue);
                onReload();
                close();
            } catch (error) {
                console.error(error);
            }
        },
    });

  return (
    <Form className='edit-market-form' onSubmit={formik.handleSubmit}>
        
        <Form.Input
            name='supportEmail'
            type='email'
            label='Support Email'
            onChange={formik.handleChange}
            value={formik.values.supportEmail}
            error={formik.errors.supportEmail}
        />

       <Form.Input
            name='market'
            type='text'
            label='Market'
            onlyRead
            value={formik.values.market}
            error={formik.errors.market}
        />

        <Form.Input
            name='address'
            type='text'
            label='Address'
            onlyRead
            placeholder=''
            value={formik.values.address}
            error={formik.errors.address}
        />

        <Form.Input
            name='enode'
            type='text'
            label='enode'
            onlyRead
            placeholder=''
            value={formik.values.enode}
            error={formik.errors.enode}
        />

        <Form.Input
            name='network'
            type='text'
            label='Network'
            onlyRead
            placeholder=''
            value={formik.values.network}
            error={formik.errors.network}
        />

        <Form.Input
            name='membership'
            type='text'
            label='Membership'
            onlyRead
            placeholder=''
            value={formik.values.membership}
            error={formik.errors.membership}
        /> 

        <Form.Group widths='equal'>
            <Form.Button type='submit' primary fluid loading={formik.isSubmitting}>
                {"Register"}
            </Form.Button>
            <Form.Button type='button' secondary fluid onClick={close}>
                {"Cancel"}
            </Form.Button>
        </Form.Group>
    </Form>
  )
}
